import React, { useEffect, useRef, useState } from "react";

import { Bot, SendHorizontal, User } from "lucide-react";
import Navbar from "../components/Navbar";
import axios from "axios";

const MedicineChatbot = () => {
  const [messages, setMessages] = useState([
    { from: "bot", text: "Hi! I’m your medicine info assistant. Ask me anything about medicines." }
  ]);
  const [input, setInput] = useState("");
  const [chat_history, setchat_history] = useState("{}"); // Store history as an array
  const chatContainerRef = useRef(null)

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSend = async () => {
    if (!input.trim()) return;

    // Add user message to chat
    const newMessages = [...messages, { from: "user", text: input }];
    setMessages(newMessages);
    setInput("");

    // Append user input to chat_history

    try {
      // Make API request to backend
      const response = await axios.post("https://lovencare.gopillz.com/api/medicine_chat", 
        {
          message: input,
          session_id: localStorage.getItem("session_id") || null, // session_id can be stored in localStorage
          history: chat_history, // Send the existing chat history
          lang:"english"
        },
        { headers: { "Content-Type": "application/json" } }
      );

      // Get response data from the API
      const { session_id, response: botResponse, history_user: updatedChatHistoryFromAPI } = response.data;

      // Update chat history with bot's response
      setchat_history(updatedChatHistoryFromAPI);

      // Store session_id in localStorage
      localStorage.setItem("session_id", session_id);

      // Add bot's response to messages
      setMessages([
        ...messages, { from: "user", text: input },
        { from: "bot", text: botResponse },
      
    
    
    ]);

    } catch (error) {
      console.error("Error during API request:", error);
      // Handle the error gracefully (optional)
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-blue-200 via-white to-blue-100">
      <Navbar />

      <div className="flex-grow flex flex-col max-w-3xl mx-auto w-full px-4 sm:px-6 py-6">
        <h2 className="text-4xl font-extrabold text-blue-800 mb-6 text-center flex items-center justify-center gap-3">
          <Bot className="w-7 h-7 text-blue-600" /> Medicine Info
        </h2>

        <div
          ref={chatContainerRef}
          className="flex flex-col gap-4 bg-white/70 backdrop-blur-md p-6 rounded-3xl shadow-xl h-[500px] overflow-y-auto border border-blue-200 scrollbar-thin scrollbar-thumb-blue-300 scrollbar-track-transparent"
        >
          {messages.map((msg, index) => (
            <div
              key={index}
              className={`flex items-start gap-3 text-sm ${
                msg.from === "bot" ? "self-start" : "self-end flex-row-reverse"
              }`}
            >
              <div className={`rounded-full p-1 ${msg.from === "bot" ? "bg-blue-200" : "bg-blue-600"}`}>
                {msg.from === "bot" ? (
                  <Bot className="w-5 h-5 text-white" />
                ) : (
                  <User className="w-5 h-5 text-white" />
                )}
              </div>
              <div
                className={`max-w-[75%] px-4 py-2 rounded-2xl whitespace-pre-wrap leading-relaxed ${
                  msg.from === "bot"
                    ? "bg-blue-100 text-blue-900 shadow"
                    : "bg-blue-600 text-white shadow"
                }`}
              >
                {msg.text}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 flex items-center gap-3">
          <input
            type="text"
            className="flex-grow px-5 py-3 rounded-full border border-blue-300 shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-400 transition placeholder:text-blue-400"
            placeholder="Ask your medicine-related question..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSend()}
          />
          <button
            onClick={handleSend}
            className="bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-full shadow-lg transition"
          >
            <SendHorizontal className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};


export default MedicineChatbot;
